import { useDyteMeeting } from '@dytesdk/react-web-core';
import { BsRecord2 } from 'react-icons/bs';

const Recording = () => {
	const dyteMeeting = useDyteMeeting();

	if (dyteMeeting.meeting.recording.recordingState === 'RECORDING')
		return (
			<div className={'flex gap-2 justify-between items-center text-sm text-red-500'}>
				<BsRecord2 className="h-6 w-6" />
				REC
			</div>
		);
	else return <div />;
};

export default Recording;
